var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9902 2.5C17.5201 2.50013 22 6.98008 22 12.5C22 18.0199 17.5201 22.4999 11.9902 22.5C6.47023 22.5 2 18.02 2 12.5C2 6.98 6.47023 2.5 11.9902 2.5ZM12 4.5C7.58 4.5 4 8.08 4 12.5C4 16.92 7.58 20.5 12 20.5C16.42 20.5 20 16.92 20 12.5C20 8.08 16.42 4.5 12 4.5ZM13 17.5H11V15.5H13V17.5ZM12 7.5C12.55 7.5 13 7.95 13 8.5V12.5C13 13.05 12.55 13.5 12 13.5C11.45 13.5 11 13.05 11 12.5V8.5C11 7.95 11.45 7.5 12 7.5Z",
    fill: "#FD6157"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastError);
export default __webpack_public_path__ + "static/media/toast-error.76265b745debeb6d9fd5ebb2e00c77a0.svg";
export { ForwardRef as ReactComponent };